import { render, staticRenderFns } from "./PurchaseGroupSelect.vue?vue&type=template&id=219a6922&scoped=true&"
import script from "./PurchaseGroupSelect.vue?vue&type=script&lang=js&"
export * from "./PurchaseGroupSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "219a6922",
  null
  
)

export default component.exports